import React, { useState, useRef, useEffect } from 'react';
import { GoogleMap, StandaloneSearchBox, Marker } from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '400px'
};

function MapWithMarker({ center, onLocationUpdate }) {
    const [map, setMap] = useState(null);
    const [isGoogleLoaded, setIsGoogleLoaded] = useState(false);
    const searchBoxRef = useRef(null);

    // Check if Google Maps is already loaded
    useEffect(() => {
        const checkGoogleMaps = () => {
            if (window.google && window.google.maps) {
                setIsGoogleLoaded(true);
            } else {
                // Wait a bit and check again
                setTimeout(checkGoogleMaps, 100);
            }
        };
        checkGoogleMaps();
    }, []);

    const onLoad = ref => {
        searchBoxRef.current = ref;
    };

    // Geocode coordinates to get address and area
    const geocodeLocation = (lat, lng) => {
        if (!window.google || !window.google.maps) return;
        
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === 'OK' && results[0]) {
                const address = results[0].formatted_address;
                let area = 'N/A';
                
                // Extract area from neighborhood or sublocality
                for (let i = 0; i < results[0].address_components.length; i++) {
                    for (let j = 0; j < results[0].address_components[i].types.length; j++) {
                        switch (results[0].address_components[i].types[j]) {
                            case "neighborhood":
                                area = results[0].address_components[i].short_name;
                                break;
                            case "sublocality":
                                area = results[0].address_components[i].short_name;
                                break;
                            default:
                                break;
                        }
                    }
                }
                
                // Call the callback with complete location data
                onLocationUpdate({
                    latLng: { lat, lng },
                    address: address,
                    area: area
                });
            } else {
                console.error("Geocoding failed:", status);
                // Still update coordinates even if geocoding fails
                onLocationUpdate({
                    latLng: { lat, lng },
                    address: '',
                    area: ''
                });
            }
        });
    };

    const onPlacesChanged = () => {
        const places = searchBoxRef.current.getPlaces();
        const place = places[0];
        if (place) {
            const { geometry } = place;
            if (geometry && geometry.location) {
                const lat = geometry.location.lat();
                const lng = geometry.location.lng();
                geocodeLocation(lat, lng);
            }
        }
    };

    // Don't render until Google Maps is loaded
    if (!isGoogleLoaded) {
        return (
            <div style={containerStyle} className="d-flex align-items-center justify-content-center">
                <div>Loading map...</div>
            </div>
        );
    }

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={15}
            defaultZoom={15}
            onLoad={map => setMap(map)}
            onDragEnd={() => {
                let center = map?.getCenter()?.toJSON()
                if (center) {
                    geocodeLocation(center.lat, center.lng);
                }
            }}
            options={{ disableDefaultUI: true }}
        >
            <StandaloneSearchBox
                onLoad={onLoad}
                onPlacesChanged={onPlacesChanged}
            >
                <input
                    type="text"
                    placeholder="Search places"
                    style={{
                        boxSizing: 'border-box',
                        border: '1px solid transparent',
                        width: '240px',
                        height: '32px',
                        padding: '0 12px',
                        borderRadius: '3px',
                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                        fontSize: '14px',
                        outline: 'none',
                        textOverflow: 'ellipses',
                        position: 'absolute',
                        top: '10px',
                        left: '10px'
                    }}
                />
            </StandaloneSearchBox>
            <Marker position={center} />
        </GoogleMap>
    );
}

export default MapWithMarker;
